<template>
  <div class="wet-cat-pay">
    <el-form :model="formData" ref="formData" label-width="80px" size="small">
      <!-- 所有信息合并到一个卡片 -->
      <div class="form-section">
        <h3>客户信息</h3>
        <!-- 原基础信息部分 -->
        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="订单号" class="compact-form-item">
              <el-input v-model="displayData.orderNumber" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属代理商" class="compact-form-item">
              <el-input v-model="displayData.ownerAgent" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="ICCID" class="compact-form-item">
              <el-input v-model="displayData.cardNumber" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="微信订单号" class="compact-form-item">
              <el-input v-model="displayData.transactionId" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="虚拟号" class="compact-form-item">
              <el-input v-model="displayData.virtualNumber" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="接入号" class="compact-form-item">
              <el-input v-model="displayData.phone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="下单时间" class="compact-form-item">
              <el-input v-model="quantityData[0].orderTime" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="套餐名称" class="compact-form-item">
              <el-input v-model="displayData.packageName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="套餐类型" class="compact-form-item">
              <el-input v-model="displayData.packageType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开卡公司" class="compact-form-item">
              <el-input v-model="quantityData[0].openCompany" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="来源" class="compact-form-item">
              <el-input :value="this.orderData.orderSourceStr || ''" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="下单金额" class="compact-form-item">
              <el-input :value="Number(this.orderData.orderMoney) || 0" disabled>
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="数量" class="compact-form-item">
              <el-input v-model="quantityData[0].quantity" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付状态" class="compact-form-item">
              <el-input v-model="displayData.paymentStatus" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="充值类型" class="compact-form-item">
              <el-input v-model="quantityData[0].rechargeType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="返现金额" class="compact-form-item">
              <el-input :value="Number(this.orderData.fandianMoney) || 0" disabled>
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="未返现金额" class="compact-form-item">
              <el-input :value="Number(this.orderData.noMfAmount) || 0" disabled>
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="秒返金额" class="compact-form-item">
              <el-input :value="Number(this.orderData.mfAmount) || 0" disabled>
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="成本价" class="compact-form-item">
              <el-input :value="Number(this.orderData.costPrice) || 0" disabled>
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    
    <!-- 底部按钮 -->
    <!-- <div class="form-buttons">
      <el-button type="primary" @click="submitForm">提交申请</el-button>
      <el-button @click="resetForm">重置</el-button>
    </div> -->
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'WetCatPay',
  props: {
    records: {
      type: Array,
      default: () => []
    },
    orderData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    orderData: {
      handler(oldVal, newVal) {
          console.log('orderData发生变化:', newVal);
      },
      deep: true
    },
    records: {
      handler(oldVal, newVal) {
          console.log('records发生变化:', newVal);
      },
      deep: true
    } 
  },
  data() {
    return {
      formData: {
        orderNumber: '',
        ownerAgent: '',
        cardNumber: '',
        insertNumber: '',
        virtualNumber: '',
        packageName: '',
        receivingCustomer: '',
        rechargeStatus: '',
        packageType: '',
        orderAmount: '',
        paymentStatus: '',
        paymentMethod: '',
        source: ''
      },
      quantityData: [
        {
          fandianMoney:'',
          quantity: 1,
          openCompany: '',
          rechargeType: '',
          orderTime: '',
          returnAmount: '',
          unreturnedAmount: '',
          cost: ''
        }
      ],
      currentTime: new Date().toLocaleString()
    }
  },
  computed: {


    
    displayData() {
      if (this.orderData && Object.keys(this.orderData).length > 0) {
        console.log('WetCatPay组件使用orderData:', this.orderData);
        console.log('WetCatPay组件使用records:', this.records);
        
        // 更新quantityData数组
        this.updateQuantityData();
        
        // 将API返回的数据映射到表单字段
        return {
          orderNumber: this.orderData.orderNumber || '',
          ownerAgent: this.orderData.agentName || '',
          cardNumber: this.orderData.cardId || '',
          insertNumber: '',
          virtualNumber: this.orderData.vcode || '',
          packageName: this.orderData.mealName || '',
          receivingCustomer: this.orderData.accountName || '',
          rechargeStatus: '成功',
          packageType: this.orderData.mealTypeStr || '',
          orderAmount: this.orderData.orderMoney || '0',
          paymentStatus: this.orderData.payStatusStr || '',
          paymentMethod: this.orderData.kind === 1 ? '线上购买' : '充值订单',
          source: this.orderData.orderSourceStr || '',
          agentName: this.orderData.agentName || '',
          cardId: this.orderData.cardId || '',
          wxOrderId: this.orderData.wxOrderId || '',
          transactionId: this.orderData.transactionId || '',
          rechargeMoney: Number(this.orderData.rechargeMoney) || 0,
          giftMoney: Number(this.orderData.fandianMoney) || 0,
          rsourceStr: this.orderData.orderSourceStr || this.orderData.rsourceStr || '',
          phone: this.orderData.phone || '',
          virtualNumber: this.orderData.vcode || '',
         orderAmount: Number(this.orderData.orderMoney) || 0,
          fandianMoney:this.orderData.fandianMoney
        };
      }
      return this.formData;
    }
  },
  methods: {
    // 更新quantityData数组
    updateQuantityData() {
      if (this.orderData && Object.keys(this.orderData).length > 0) {
        // 打印orderData的所有字段
        console.log('orderData的所有字段:', Object.keys(this.orderData));
        
        this.quantityData = [{
          quantity: Number(this.orderData.orderCount) || 1,
          openCompany: this.orderData.accountName || '', // 开卡公司对应accountName
          rechargeType: this.orderData.isFirstRechargeStr || '', // 充值类型对应isFirstRechargeStr
          orderTime: this.orderData.createTime || '', // 下单时间使用createTime
          returnAmount: Number(this.orderData.noMfAmount) || 0, // 未返现金额对应noMfAmount
          unreturnedAmount: Number(this.orderData.mfAmount) || 0, // 秒返金额对应mfAmount
          cost: Number(this.orderData.costPrice) || 0, // 成本价对应costPrice
          // 尝试不同的字段名称
          rsourceStr: this.orderData.orderSourceStr || this.orderData.rsourceStr || '', // 来源对应orderSourceStr或rsourceStr
          fandianMoney: Number(this.orderData.fandianMoney) || 0 ,// 返现金额对应fandianMoney
       
        }];
        
        console.log('更新后的quantityData:', this.quantityData);
      }
    },
    // 更新当前时间
    updateCurrentTime() {
      this.currentTime = new Date().toLocaleString();
    },
    
    // 提交表单
    submitForm() {
      try {
        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 准备请求数据
        const requestData = {
          "refund_type": 2, // 退款类型 2-充值订单
          "reception_date": new Date().toISOString().replace('T', ' ').substring(0, 19), // 接待日期
          "source_channel": this.orderData.rsource || "10001", // 来源渠道
          "card_no": this.displayData.cardNumber || "", // 卡号
          "team": this.orderData.teamId || "1223", // 所属团队
          "agent_level": this.orderData.agentThreeName || "22222", // 代理层级
          "payment_screenshot": this.orderData.paymentImage || "", // 支付凭证
          "payment_time": this.quantityData[0].orderTime ? new Date(this.quantityData[0].orderTime).toISOString().replace('T', ' ').substring(0, 19) : new Date().toISOString().replace('T', ' ').substring(0, 19), // 支付时间
          "refundable_amount": Number(this.orderData.orderMoney) || 0, // 可退金额
          "refund_path": "原路退回", // 退款路径
          "refund_channel": "收款账号", // 退款方式
          "refund_reason": "客户申请退款", // 退款原因
          "refund_applicant": this.displayData.ownerAgent || "", // 收款申请人
          "account_number": "" // 收款账号
        };

        console.log('提交退款申请请求数据:', requestData);

        // 发送请求
        request({
          url: '/api/v1/kf-refound/apply',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          },
          data: requestData
        }).then(response => {
          // 关闭加载状态
          loading.close();

          if (response && response.status === 1) {
            this.$message.success('退款申请提交成功');
            // 成功后跳转到我的申请列表页面
            this.$router.push('/refund/myApplications');
          } else {
            this.$message.error(response?.msg || '提交失败，请稍后重试');
          }
        }).catch(error => {
          loading.close();
          console.error('提交退款申请出错:', error);
          this.$message.error('提交失败: ' + (error.message || '未知错误'));
        });
      } catch (error) {
        console.error('提交退款申请出错:', error);
        this.$message.error('提交失败: ' + (error.message || '未知错误'));
      }
    },
    
    // 重置表单
    resetForm() {
      this.$refs.formData.resetFields();
    }
  },
  mounted() {
    console.log('WetCatPay组件挂载完成，records:', this.records);
    console.log('WetCatPay组件挂载完成，orderData:', this.orderData);
    console.log('WetCatPay组件挂载完成，接收到的关键字段:', {
      orderSourceStr: this.orderData.orderSourceStr,
      mfAmount: this.orderData.mfAmount,
      fandiankMoney: this.orderData.fandiankMoney
    });
    
    // 初始化数据
    if (this.orderData && Object.keys(this.orderData).length > 0) {
      this.updateQuantityData();
    }
    
    // 更新当前时间
    this.updateCurrentTime();
  }
}
</script>

<style lang="scss" scoped>
.wet-cat-pay {
  margin-top: 5px;
  margin-bottom: 5px;
  
  .form-section {
    background: linear-gradient(to right, #d4e4f7, #b4c6e9);
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.12);
    border: 1px solid #93b3e4;
    
    h3 {
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 16px;
      color: #2c4b80;
      font-weight: 600;
      padding-bottom: 5px;
      border-bottom: 1px solid #93b3e4;
    }
  }
  
  .compact-form-item {
    margin-bottom: 5px;
    
    :deep(.el-form-item__label) {
      padding: 0 5px 0 0;
      line-height: 24px;
      color: #3a5d99;
      font-weight: 500;
    }
    
    :deep(.el-form-item__content) {
      line-height: 24px;
    }
    
    :deep(.el-input__inner) {
      height: 24px;
      line-height: 24px;
      background-color: rgba(255, 255, 255, 0.9);
      border-color: #93b3e4;
      
      &:disabled {
        background-color: #e0ebf9;
        color: #4a5b7b;
        cursor: not-allowed;
      }
    }
    
    :deep(.el-input-group__append) {
      background-color: #b4c6e9;
      color: #2c4b80;
      border-color: #93b3e4;
      padding: 0 8px;
      height: 24px;
      line-height: 24px;
    }
  }
  
  :deep(.el-input__inner) {
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
  }
  
  :deep(.el-row) {
    margin-bottom: 3px;
  }
  
  :deep(.el-col) {
    padding-right: 3px;
    padding-left: 3px;
  }
}
</style>
